import { EMPTY_PROMISE } from '../../constants';

import { Modal } from './types';

export const modal_default: Modal = {
  stack: { is_open: false },
  candle_workers: { is_open: false },
  candle_validations: { is_open: false },
  strategy_manage: { is_open: false, is_update: false },
  trigger_manage: { is_open: false, is_update: false },
  condition_manage: { is_open: false, is_update: false },
  confirm: { is_open: false, title: '', message: '', onConfirm: EMPTY_PROMISE },
  error: {
    is_open: false,
    message: '',
    code: '',
    error: '',
    name: '',
    status: 0,
    payload: {},
    response: {},
    stack: null,
  },
};
